import React from "react";
import { useNavigate } from "react-router-dom";
import errorChefImage from "../assests/error_handler_chef.png";

interface ErrorHandlerPageProps {
  title?: string;
  description?: string;
  retryLabel?: string;
  onRetry?: () => void;
  homeLabel?: string;
  showHomeButton?: boolean;
  onHome?: () => void;
}

const ErrorHandlerPage: React.FC<ErrorHandlerPageProps> = ({
  title = "Unable to Complete Request",
  description = "We are experiencing a temporary issue. Please try again shortly.",
  retryLabel = "Retry",
  onRetry,
  homeLabel = "Return to Home",
  showHomeButton = true,
  onHome,
}) => {
  const navigate = useNavigate();

  const handleHome = () => {
    if (onHome) {
      onHome();
      return;
    }
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-white text-black flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <img
          src={errorChefImage}
          alt="Error illustration"
          className="w-[280px] h-[320px] object-contain mx-auto "
        />
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        <p className="text-black/70 text-sm sm:text-base mb-6">{description}</p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {onRetry && (
            <button
              onClick={onRetry}
              className="px-5 py-2.5 rounded-lg bg-main text-white font-semibold"
            >
              {retryLabel}
            </button>
          )}
          {showHomeButton && (
            <button
              onClick={handleHome}
              className="px-5 py-2.5 rounded-lg border border-black/20 text-black font-semibold"
            >
              {homeLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorHandlerPage;
